import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'
import { strToRenjuBoardCard } from '../../../lib'
import * as constants from '../../../constants'

const initialState = {
  viewMode: constants.liveListViewMode.GRID,
  boards: [],
  page: 1,
  rowsPerPage: 10,
  totalRows: 0,
  totalPage: 0,
  isFetching: false,
  search: null,
}

const liveList = (state = initialState, action) => {
  var newState, context, boards, board
  switch (action.type) {
    case types.liveList.CHANGE_VIEW_MODE:
      switch (action.mode) {
        case constants.liveListViewMode.GRID:
        case constants.liveListViewMode.TABLE:
          return { ...state, viewMode: action.mode }
        default:
          return state
      }
    case types.live.REQUEST_SELECT_BOARD_CONTEXT:
      return { ...state, isFetching: true }
    case types.live.RECEIVE_SELECT_BOARD_CONTEXT:
      newState = deepCopy(state)
      newState.totalRows = action.total ? parseInt(action.total, 10) : 0
      boards = []
      if (action.boardContexts) {
        for (context of action.boardContexts) {
          board = strToRenjuBoardCard(context)
          board = {
            ...board,
            liveId: context.liveId,
            status: context.status,
            contributor: context.contributor,
            startTime: context.startTime,
            endTime: context.endTime,
          }
          boards.push(board)
        }
      }
      newState.boards = boards
      newState.isFetching = false
      newState.search = action.search ? decodeURIComponent(action.search) : undefined
      newState.totalPage = Math.ceil(newState.totalRows / newState.rowsPerPage)
      return newState
    case types.liveList.NEXT_PAGE:
      if (state.page + 1 > state.totalPage) {
        return state
      }
      return { ...state, page: state.page + 1}
    case types.liveList.BACK_PAGE:
      if (state.page - 1 < 1) {
        return state
      }
      return { ...state, page: state.page - 1 }
    case types.liveList.CLEAR_BOARD_CONTEXT:
      return { ...state, boards: [] }
    case types.liveList.CLEAR_PAGE_NAVIGATION:
      return { ...state, page: 1 }
    default:
      return state
  }
}

export default liveList



// WEBPACK FOOTER //
// ./src/reducers/Page/Live/LiveList.js